"use strict";

var _interopRequireWildcard3 = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));

var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/objectSpread2.js"));

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));

var report = _interopRequireWildcard3(require("@/api/report"));

var inventory = _interopRequireWildcard3(require("@/api/inventory"));

var user = _interopRequireWildcard3(require("@/api/user"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _moment = _interopRequireDefault(require("moment"));

var _vuex = require("vuex");

var _Agency = _interopRequireDefault(require("@/components/Agency"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    UploadExcelComponent: _index.default,
    Pagination: _Pagination.default,
    Agency: _Agency.default
  },
  data: function data() {
    return {
      isAdmin: this.$store.getters.roles.includes("admin"),
      loadingButtonExcel: false,
      tableData: [],
      dateUpload: (0, _moment.default)().format("YYYY-MM-DD HH:mm:ss"),
      tableHeader: [],
      isLoading: false,
      dateRange: [(0, _moment.default)().format("YYYY-MM-DD"), (0, _moment.default)().format("YYYY-MM-DD")],
      agency: {
        lv1: null,
        lv2: null,
        lv3: null,
        lv4: null
      },
      level: null,
      isAll: false,
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        userId: null,
        dateFrom: (0, _moment.default)().format("YYYY-MM-DD"),
        dateTo: (0, _moment.default)().format("YYYY-MM-DD"),
        level: null
      },
      loadingButton: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["roles"])),
  methods: {
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    downloadReport: function downloadReport() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var tHeader, filterVal, query, res, dataRes;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tHeader = ["Master Agent", "Distributor", "Retailer", "Employee", "Seller", "Enrollment number", "Active time", "First call made", "First call date", "ESN", "Imei", "Found in inventory", "Device type", "Device model"];
                filterVal = ["lv1Name", "lv2Name", "lv3Name", "lv4Name", "sellerName", "enrollmentNumber", "activeTime", "firstCallMade", "firstCallDate", "esn", "imei", "foundInInventory", "deviceType", "deviceModel"];
                query = {
                  dateFrom: _this.listQuery.dateFrom,
                  dateTo: _this.listQuery.dateTo,
                  userId: _this.listQuery.userId,
                  level: _this.listQuery.level
                };
                _this.loadingButtonExcel = true;
                _context.next = 6;
                return report.getSaleReport(query);

              case 6:
                res = _context.sent;
                dataRes = res.data.data;
                Promise.resolve().then(function () {
                  return (0, _interopRequireWildcard2.default)(require("@/vendor/Export2Excel"));
                }).then(function (excel) {
                  var list = dataRes;

                  var data = _this.formatJson(filterVal, list);

                  excel.export_json_to_excel({
                    header: tHeader,
                    data: data,
                    filename: "Report_detail_".concat(_this.dateRange[0], "_").concat(_this.dateRange[1])
                  });
                  _this.loadingButtonExcel = false;
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changeDate: function changeDate(val) {
      this.listQuery.dateFrom = val[0];
      this.listQuery.dateTo = val[1];
    },
    doSearch: function doSearch() {
      var _this2 = this;

      var level = undefined;
      var currentId = undefined;
      this.agency = this.$refs["agency"].getData();
      Object.keys(this.agency).forEach(function (key, index) {
        var userId = _this2.agency[key];

        if (userId && userId != "All") {
          currentId = userId;
          level = index + 1;
        }

        if (userId) {
          _this2.level = index + 1;
        }
      });

      if (!this.level) {
        return this.$message.error("Please select agent");
      }

      this.listQuery.level = level;
      this.listQuery.userId = currentId;
      this.isAll = false;
      this.loadingButton = true;
      report.getSaleReport((0, _objectSpread2.default)({}, this.listQuery)).then(function (res) {
        _this2.tableData = res.data.data;
        _this2.total = res.data.total;
      }).finally(function () {
        _this2.loadingButton = false;
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isLt1M = file.size / 1024 / 1024 < 100;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: "Please do not upload files larger than 100MB in size.",
        type: "warning"
      });
      return false;
    },
    handleSuccess: function handleSuccess(_ref) {
      var _this3 = this;

      var results = _ref.results,
          header = _ref.header;
      var data = {
        data: results,
        date: (0, _moment.default)().format("YYYY-MM-DD HH:mm:ss")
      };
      this.isLoading = true;
      (0, report.importSaleReport)(data).then(function (res) {
        _this3.$message({
          type: "success",
          message: res.message
        });
      }).finally(function () {
        _this3.isLoading = false;
      });
    }
  }
};
exports.default = _default;